import { Box, MenuItem, Select, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { renderColorByString } from '../DataGrid/renderColorByString'
const EditSelectCell = ({ params, options }) => {
  const [open, setOpen] = useState(true) // Keep dropdown open initially
  const theme = useTheme()
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    setOpen(false)
    params.api.stopCellEditMode({ id: params.id, field: params.field })
  }

  return (
    <Select
      autoFocus
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      value={params.value || 'On Hold'}
      onChange={e => {
        const newValue = e.target.value
        // Update the cell value
        params.api.setEditCellValue(
          {
            id: params.id,
            field: params.field,
            value: newValue,
          },
          e
        )
        // Immediately exit edit mode so the update is applied right away
        params.api.stopCellEditMode({ id: params.id, field: params.field })
      }}
      fullWidth
      sx={{
        bgcolor: theme.palette.background.paper,
        '& .MuiSelect-select': {
          bgcolor: theme.palette.background.paper,
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            bgcolor: theme.palette.background.paper,
          },
        },
      }}
    >
      {options.map(option => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{ color: option?.color ?? renderColorByString(option.value) }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography>{option.label}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  )
}
export default EditSelectCell
